// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1Suc4","content":"Consent_content__vLJPH","footer":"Consent_footer__2CbfO"};